import { useState, useEffect, useRef } from "react";
import { flushSync } from "react-dom";
import Header from '../../../Components/Header/header';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { showSuccess, showError, showWarning, showCustomAlert, showSessionExpired } from '../../../Utils/swal';
import Refresh from '../../../Components/refresh/refresh';
import Writing from '../../../Components/typewriter/typewriter';
import '../../../css/loader.css';
import config from '../../../Context/Config';
import { toJpeg } from 'html-to-image';
import SelectInput from "../../../Components/selectInput/select";
import InjectionConsent from "../../../Components/injection/injection";
import BackgruseRedirectIfNotLoggedIn from '../../../Components/redirect/redirect';
import { refreshToken } from '../../../Context/RefreshToken';
import { updateCode } from "../../../Utils/updateCode";
import { compressImageForIOS } from "../../../Utils/compress";
import { checkTokenAndNavigate } from "../../../Utils/checkNavigate";
import DynamicCheckbox from "../../../Components/selectInput/consent";
import { rsiphysicians } from '../../../Utils/Options'
import Paragraph from "../../../Components/paragraph/paragrah";
import MultiSelector from '../../../Components/selectInput/roundedms'; import PatientSignatureImage from '../../../Components/signature/PatientSignatureImage';
import SignaturePopup from "../../../Components/signature/signaturePopup";
import { formattingDate } from "../../../Utils/formatDate";
import { useZoom } from "../../../Context/Zoom";
import { useAutoTokenRefresh } from "../../../Context/refresh";
import useBackLock from "../../../Utils/backLock";
import Rocket from '../../../Components/rocket/rocket';
import CheckboxGroup from "../../../Components/selectInput/checkBox";
import FormHeader from "../../../Components/formHeaders/formheaders";
import RadioGroup from "../../../Components/radio/radio";
import TextInput from "../../../Components/textInput/textInput";
import DiagnosisMultiSelect from "../../../Components/selectInput/DiagnosisMultiSelect"

const Injection = () => {
    useBackLock()
    const { zoom, setZoom } = useZoom();
    const [nextLoader, setNextLoader] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const location = useLocation();
    const { openedViaButton, shouldValidate } = location.state || {};
    const dept_name = localStorage.getItem("digital-form-dept-practice")
    BackgruseRedirectIfNotLoggedIn(openedViaButton, 50, "/context-not-found");
    const navigate = useNavigate();
    const { chart, apptId } = useParams();
    const [pageTitle, setPageTitle] = useState('');
    const [encId, setEncId] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading3, setIsLoading3] = useState(false);
    const [isLoading4, setIsLoading4] = useState(false);
    const [showSignaturePopup, setShowSignaturePopup] = useState(false);
    const taskRunRef = useRef(false);
    const pageRef = useRef(null);
    const pages = useRef([]);
    useAutoTokenRefresh({ navigate, intervalMs: 5 * 60 * 1000 });
    const currentDate = new Date();
    const formatDate = (date) => {
        try {
            const formattedDate = formattingDate(date);
            return formattedDate
        } catch (err) {
            console.error('Error formatting date:', err.message);
        }
    };

    const formattedDate = formatDate(currentDate); // Formats current date
    const [InjectionConsentForm, setInjectionConsentForm] = useState({
        "tech_signature": "",
        "flagged": null,
        "doctor_signature": "",
        "patient_signature": null,
        "inventory": [],
        "diagnosis": {
            "Branched Retina Vein Occlusion": { "icd10": "", "OD": null, "OS": null },
            "Central Retina Vein Occlusion": { "icd10": "", "OD": null, "OS": null },
            "Cystoid Macular Edema": { "icd10": "", "OD": null, "OS": null },
            "Macular Retina Edema": { "icd10": "", "OD": null, "OS": null },
            "Proliferative Diabetic Retinopathy": { "icd10": "", "OD": null, "OS": null },
            "Diabetic macular edema": { "icd10": "", "OD": null, "OS": null },
            "Neovascular glaucoma": { "icd10": "", "OD": null, "OS": null },
            "Panuveitis": { "icd10": "", "OD": null, "OS": null },
            "Retina Tear": { "icd10": "", "OD": null, "OS": null },
            "Retina detachment": { "icd10": "", "OD": null, "OS": null },
            "Endophthalmitis": { "icd10": "", "OD": null, "OS": null },
            "Chorioretinitis, unspecified": { "icd10": "", "OD": null, "OS": null },
            "Wet AMD": { "icd10": "", "OD": null, "OS": null },
            "Dry AMD": { "icd10": "", "OD": null, "OS": null },
            "Other": { "icd10": "", "OD": null, "OS": null },
        },
        "procedures": {
            "Avastin injection": false,
            "Lucentis injection-0.5mg": false,
            "Lucentis injection-0.3mg": false,
            "Ozurdex injection": false,
            "Eylea injection": false,
            "Beovu injection": false,
            "Subtenons Kenalog injection": false,
            "Triesence or Kenalog injection": false,
            "Eylea HD injection": false,
            "Susvimo Injection": false,
            "Other": false,
            "Vabysmo Injection": false,
            "Syfovre Injection": false,
            "Byooviz Injection": false,
            "Cyclophotocoagulation": false,
            "Cryotherapy": false,
            "A/C Paracentesis therapeutic": false,
            "Ceftazidime injection": false,
            "Vancomycin injection": false,
            "Xipere injection": false,
            "Cimerli Injection": false,
            "Focal Laser/Grid": false,
            "Laser Panretinal Photocoagulation": false,
            "Pneumatic Retinopexy": false,
            "Vitreous Tap Diagnostic": false,
            "Corneal FB Removal": false,
            "Laser Repair of retina detachment": false,
            "Prophylactic/Demarcation": false,
            "Methotrexate": false,
            "Izervay Injection": false,
            "PavBlu Injection": false
        },
        "od": false,
        "os": false,
        "first_name": "",
        "last_name": "",
        "dob": "",
        "doctor": "",
        "alternative": false,
        "checks": {
            "Consent Signed": true,
            "Patient Dilated": true,
            "Iodine in Formix": true,
            "Tetracaine Applied": true,
            "Vigamox Applied": null
        },
        "other_procedure": "",
        "other_diagnosis": ""
    });
    // Enhanced image loading with better error handling


    const [localpatientid, setlocalpatientid] = useState("");
    const [invalidFields, setInvalidFields] = useState([]);
    const [fileUpload, setFileUpload] = useState(false);
    const [signatures, setSignatures] = useState({
        patient_signature: ""
    });
    const canvasRefs = {
        patient_signature: useRef(null),
    };


    const handleCheckboxChange = (key, value) => {
        setInjectionConsentForm((prev) => ({
            ...prev,
            [key]: value, // Dynamically set the key with the value
        }));
    };


    const tryRefresh = async (autoReloadBool) => {
        try {
            setIsLoading3(true)
            await refreshToken({
                navigate,
                onSuccess: (token) => console.log("Refreshed:", token),
                onError: (err) => console.error("Failed to refresh", err),
                autoReload: autoReloadBool
            });
        }
        finally {
            setIsLoading3(false)
        }
    };

    // Function to handle API call
    const runTask = async () => {
        setIsLoading4(true);
        if (taskRunRef.current) return; // Prevent running if task has already been executed
        taskRunRef.current = true;

        try {
            const response = await fetch(`${config.API_BASE_URL}/injection/get_injection_consent_form`, {
                method: 'POST',
                headers: {
                    "action_id": config.ACTIONID['view'], // Assuming this is set correctly
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": dept_name
                },
                body: JSON.stringify({
                    apptId: apptId,
                    dept_id: `${localStorage.getItem("digital-form-dept-id")}`,
                    practice: dept_name,
                    chart: chart
                }),
            });
            if (response.ok) {
                let data = await response.json();
                const patientId = data?.localpatientid ?? chart;
                flushSync(() => setlocalpatientid(patientId));

                const dbData = data || {};
                setEncId(dbData.encounter_id ? true : false)
                setInjectionConsentForm(prevState => ({
                    ...prevState,
                    first_name: dbData.first_name || dbData.firstname || "",
                    last_name: dbData.last_name || dbData.lastname || "",
                    dob: dbData.dob || "",
                    tech_signature: dbData.tech_signature || "",
                    doctor_signature: dbData.doctor_signature || "",
                    patient_signature: dbData.patient_signature ?? "",
                    flagged: dbData.flagged ?? null,
                    inventory: dbData.inventory || [],
                    diagnosis: dbData.diagnosis || InjectionConsentForm.diagnosis,
                    procedures: dbData.procedures || InjectionConsentForm.procedures,
                    other_procedure: dbData.other_procedure || null,
                    other_diagnosis: dbData.other_diagnosis || "",
                    od: dbData.od ?? false,
                    os: dbData.os ?? false,
                    alternative: dbData.alternative ?? false,
                    doctor: dbData.doctor || ""
                }));
                setSignatures((prev) => ({
                    ...prev,
                    patient_signature: dbData.patient_signature ?? ""
                }));
                if (!dbData.patient_signature) {
                    setShowSignaturePopup(true);
                }
            } else {
                if (response.status === 401) {
                    showSessionExpired(() => tryRefresh(true));
                } else if (response.status === 403) {
                    showWarning("Forbidden", "You don't have permission to view the patient data.");
                } else if (response.status === 500) {
                    showError("Server Error", "There was a server error while fetching the patient data. Please try again later.");
                } else {
                    showError("Error", "There was an issue fetching the patient data. Please try again later.");
                }
            }
        } finally {
            // Reset loading state
            setIsLoading4(false);
        }
    };

    useEffect(() => {
        if (openedViaButton && !taskRunRef.current) {
            localStorage.setItem("digital-form-locked", true);
            checkTokenAndNavigate(runTask, tryRefresh, navigate);

        }
    }, [openedViaButton]);

    const ButtonGroup = ({
        isSubmitted,
        currentPage,
        handleEdit,
        handleNext,
        handleFormSubmit,
        handleBack
    }) => {
        const buttonClass =
            "px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all";

        let targetPage = 1; // Default to page 0

        const shouldShowRegisterButton = (currentPage === targetPage)

        return <div className="flex justify-end space-x-2 p-5 pt-0">

            {shouldShowRegisterButton ? (
                <button onClick={handleFormSubmit} className={buttonClass}>
                    <i className="fas fa-user-plus mr-2"></i> Submit Consent
                </button>
            ) : (
                <>
                    {
                        (currentPage !== 1) && (
                            <button
                                type="button"
                                onClick={handleBackClick}
                                className={buttonClass}
                                id="back"
                            >
                                <i className="fas fa-arrow-left mr-2"></i> Previous
                            </button>
                        )
                    }
                    <button
                        type="button"
                        onClick={handleNext}
                        className={buttonClass}
                        id="next"
                    >
                        <i className="fas fa-arrow-right mr-2"></i> Next
                    </button>
                </>

            )}
        </div>
    };


    useEffect(() => {
        // Set the title based on the current page
        setPageTitle('Minor Procedure Consent');
    }, [setPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setInjectionConsentForm((prev) => ({
            ...prev,
            [id]: value,  // For other fields, update normally
        }));
    };

    const PAGE_WIDTH = 1200;  // target width
    const SCALE = 0.7;        // scale factor to shrink height visually

    async function capturePageAsImage() {
        try {
            let page = pageRef.current;

            const node = page;
            if (!node) throw new Error("Invalid page reference");

            // Save original styles
            const originalStyle = {
                width: node.style.width,
                height: node.style.height,
                overflow: node.style.overflow,
                transform: node.style.transform,
                transformOrigin: node.style.transformOrigin,
            };

            // Temporarily expand container and scale it
            node.style.width = `${PAGE_WIDTH}px`;
            node.style.height = "auto";
            node.style.overflow = "visible";
            node.style.transformOrigin = "top left";
            node.style.transform = `scale(${SCALE})`;

            // Wait for layout/rendering
            await new Promise((resolve) => setTimeout(resolve, 50));

            // Capture the scaled content
            const image = await toJpeg(node, {
                quality: 0.99,
                backgroundColor: "#FFFFFF",
                width: node.scrollWidth * SCALE,
                height: node.scrollHeight * SCALE,
                pixelRatio: 3, // higher DPI for better quality
            });

            // Restore original styles
            node.style.width = originalStyle.width;
            node.style.height = originalStyle.height;
            node.style.overflow = originalStyle.overflow;
            node.style.transform = originalStyle.transform;
            node.style.transformOrigin = originalStyle.transformOrigin;
            pages.current.push(image);
            return image;
        } catch (error) {
            console.error("Error capturing page:", error);
            throw error;
        }
    }

    const validatePage1 = () => {
        // Define required fields
        const REQUIRED_FIELDS = [
            { field: "patient_signature", label: "Patient Signature" },
            { field: "doctor", label: "Doctor" },
        ];

        // Reset invalid fields
        setInvalidFields([]);
        const invalidFields = [];

        // Validate required fields
        REQUIRED_FIELDS.forEach(({ field, label }) => {
            const value = InjectionConsentForm[field];
            if (!String(value || "").trim()) {
                invalidFields.push(label);
            }
        });

        // Check if neither OD nor OS is selected
        if (!InjectionConsentForm.od && !InjectionConsentForm.os) {
            showWarning("Eye Selection Required", "Please select at least one eye (OD or OS)");
            return false;
        }

        // Check if any diagnosis is selected
        const diagnosisList = InjectionConsentForm.diagnosis || {};
        const hasDiagnosis = Object.values(diagnosisList).some(d => d?.OD === true || d?.OS === true);
        if (!hasDiagnosis) {
            showWarning("Diagnosis Required", "Please select at least one diagnosis");
            return false;
        }

        // Check if any procedure is selected
        const proceduresList = InjectionConsentForm.procedures || {};
        const hasProcedure = Object.values(proceduresList).some(p => p === true);
        if (!hasProcedure) {
            showWarning("Procedure Required", "Please select at least one procedure");
            return false;
        }

        // If there are invalid fields, show an alert
        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);
            showWarning("Missing or Invalid Fields", `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`);
            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    };

    const update_database = async () => {
        const departmentData = JSON.parse(localStorage.getItem("selectedLocation"));
        const fileArray = ['procedure_consent'];

        const response = await fetch(`${config.API_BASE_URL}/update_database`, {
            method: "POST",
            headers: {
                "action_id": config.ACTIONID['edit'], // Assuming this is set correctly
                "Content-Type": "application/json",
                Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                "practice": dept_name

            },
            body: JSON.stringify({
                entID: chart,
                apptId: apptId,
                form_type: "procedure_consent",
                chart: localpatientid,
                forms: fileArray,
                form: InjectionConsentForm,
                dept_id: departmentData.id,
                practice: dept_name,
                key: `${localpatientid}-${apptId}-procedure_consent.jpg`,
            }),
        });
        if (response.ok) {
            return await response.json();
        }
        else {
            if (response.status === 401) {
                showSessionExpired(async () => {
                    await tryRefresh(false);
                    update_database();
                });
            } else if (response.status === 403) {
                showWarning("Forbidden", "You don't have permission to update demographics.");
            } else if (response.status === 500) {
                showError("Server Error", "There was a server error while updating demographics. Please try again later.");
            } else {
                showError("Error", "There was an issue while updating demographics. Please try again later.");
            }
        }
    }

    const update_code = async (code) => {
        const success = await updateCode(code, apptId, tryRefresh, "existing_patient_registration_form");
        return success
    };

    const handleLastPage = async () => {
        const image = await capturePageAsImage();
        return image;
    };

    // iOS-compatible upload function
    const uploadImageIOS = async (base64Image, url, maxRetries = 3) => {
        const debugLog = (msg, data) => console.log(`[iOS Upload] ${msg}:`, data);

        // Compress image first
        const compressedImage = await compressImageForIOS(base64Image, 0.8, 1200);

        // Convert to binary
        const base64Data = compressedImage.replace(/^data:image\/\w+;base64,/, "");
        const binaryData = atob(base64Data);
        const arrayBuffer = new Uint8Array(binaryData.length);

        for (let i = 0; i < binaryData.length; i++) {
            arrayBuffer[i] = binaryData.charCodeAt(i);
        }

        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                debugLog(`Upload attempt ${attempt}`, { size: arrayBuffer.length });

                const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });

                // Try fetch first
                try {
                    const uploadResponse = await fetch(url, {
                        method: "PUT",
                        body: blob,
                        headers: {
                            "Content-Type": "image/jpeg",
                        },
                        keepalive: false,
                        cache: 'no-cache',
                    });

                    if (uploadResponse.ok) {
                        debugLog('Fetch upload successful', { status: uploadResponse.status });
                        return uploadResponse;
                    } else {
                        throw new Error(`Fetch failed with status: ${uploadResponse.status}`);
                    }
                } catch (fetchError) {
                    debugLog('Fetch failed, trying XHR', fetchError.message);

                    // Fallback to XMLHttpRequest
                    const uploadResponse = await new Promise((resolve, reject) => {
                        const xhr = new XMLHttpRequest();

                        xhr.upload.addEventListener('progress', (e) => {
                            if (e.lengthComputable) {
                                const percentComplete = (e.loaded / e.total) * 100;
                            }
                        });

                        xhr.addEventListener('load', () => {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                resolve(xhr);
                            } else {
                                reject(new Error(`XHR failed with status: ${xhr.status}`));
                            }
                        });

                        xhr.addEventListener('error', () => reject(new Error('XHR network error')));
                        xhr.addEventListener('abort', () => reject(new Error('XHR upload cancelled')));

                        xhr.open('PUT', url);
                        xhr.setRequestHeader('Content-Type', 'image/jpeg');
                        xhr.timeout = 120000; // 2 minutes
                        xhr.send(blob);
                    });

                    debugLog('XHR upload successful', { status: uploadResponse.status });
                    return uploadResponse;
                }

            } catch (error) {
                debugLog(`Attempt ${attempt} failed`, error.message);

                if (attempt === maxRetries) {
                    throw error;
                }

                // Wait before retry
                const delay = Math.pow(2, attempt) * 1000;
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    };

    // Main Upload Function - Updated handleFormSubmit section
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        let lastPage;
        if (dept_name === 'rsi') {
            lastPage = 1
        }
        if (currentPage === lastPage && shouldValidate && encId) {
            const validate = validateForm(currentPage);
            if (!validate) {
                return;
            }
        }

        setFileUpload(true);

        try {
            const originalZoom = zoom;
            // Reset zoom to 100% before capture
            setZoom(1);
            // Capture the last page

            const capturedPage = await handleLastPage();
            setZoom(originalZoom);


            // // Update database
            const { urls, keys } = await update_database();
            if (!urls || urls.length === 0) {
                showError("Error", "No URLs returned from the server. Please try again later.");
                return;
            }

            // iOS-optimized upload process
            const uploadPromises = async () => {
                const imagesList = pages.current;
                const uploadTasks = urls.map(async (url, index) => {
                    let base64Image;
                    let fileIndexName;

                    if (dept_name === "rsi") {
                        try {
                            base64Image = imagesList[0];

                            await uploadImageIOS(base64Image, url);

                            return { success: true, url, fileIndexName };

                        } catch (error) {
                            console.error(`Upload failed for ${fileIndexName}:`, error.message);
                            return { success: false, url, error, fileIndexName };
                        }
                    }

                }
                )

                // Process uploads with some concurrency but not all at once (iOS memory management)
                const results = [];
                const batchSize = 2; // Process 2 uploads at a time

                for (let i = 0; i < uploadTasks.length; i += batchSize) {
                    const batch = uploadTasks.slice(i, i + batchSize);
                    const batchResults = await Promise.all(batch);
                    results.push(...batchResults);

                    // Small delay between batches for iOS
                    if (i + batchSize < uploadTasks.length) {
                        await new Promise(resolve => setTimeout(resolve, 500));
                    }
                }

                return results;
            };

            const results = await uploadPromises();
            const failedUploads = results.filter((result) => !result.success);

            if (failedUploads.length > 0) {
                console.error('Failed uploads:', failedUploads);
                const failedFileNames = failedUploads.map((fail) => fail.fileIndexName || 'Unknown').join(', ');

                showCustomAlert(
                    "error",
                    "Upload Failed",
                    `Some files failed to upload: ${failedFileNames}. This may be due to network issues or file size. The upload will be retried.`,
                    "Retry",
                    () => setTimeout(() => handleFormSubmit(e), 1000)
                );
            } else {
                Swal.fire({
                    icon: "success",
                    title: "Upload Complete",
                    text: "Please return the tablet back to the front desk.",
                    html: `
                  <p class="text-center mt-3 font-bold text-2xl">Please return the tablet back to the front desk.</p>
                    <p class="text-center mt-3 font-semibold text-xl">Provide a PIN:</p>
                      <input id="swal-input1" type="number" class="swal2-input" placeholder="Enter PIN" min="1000" max="9999" />
                    `,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                    preConfirm: async () => {
                        const input1 = document.getElementById("swal-input1").value;

                        if (!input1) {
                            Swal.showValidationMessage("Please enter the pin");
                            return false;
                        }

                        try {
                            const response = await update_code(input1);
                            if (!response) {
                                throw new Error("Invalid pin or update failed");
                            }
                            return true;
                        } catch (error) {
                            Swal.showValidationMessage(error.message || "An error occurred, please try again");
                            return false;
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        showSuccess("Success", "The pin is verified successfully").then(() => {
                            localStorage.setItem("digital-form-locked", false);
                            navigate('/daily-appointments');
                        });
                    }
                });
            }



        } catch (error) {
            console.error('Form submission error:', error);
            showCustomAlert(
                "error",
                "Upload Failed",
                `Error: ${error.message}`,
                "Retry",
                () => setTimeout(() => handleFormSubmit(e), 1000)
            );
        } finally {
            setFileUpload(false);
        }
    };

    const validateForm = (page) => {
        switch (page) {
            case 1:
                return validatePage1()
            default:
                return true;
        }
    };

    const handleNext = async (e) => {
        try {
            e.preventDefault();

            if (shouldValidate && !validateForm(currentPage) && encId) {
                return;
            }

            // setIsNext(true);
            setNextLoader(true);
            await capturePageAsImage(currentPage);

            setNextLoader(false);


        } finally {
            // setIsNext(false);
            setNextLoader(false);
        }
    };

    const handleBackClick = () => {
        if (currentPage === 1) {
            return;
        }
    };

    const handleSignaturePopupClose = () => {
        setShowSignaturePopup(false);
    };

    const handleSignatureSave = (fieldName, signatureData, fullName) => {
        setInjectionConsentForm((prev) => ({
            ...prev,
            [fieldName]: signatureData,
        }));
        setSignatures((prev) => ({
            ...prev,
            [fieldName]: signatureData,
        }));

        setShowSignaturePopup(false);
    };

    return (
        <div className="min-h-screen flex justify-center bg-gray-50">
            <div className="min-h-screen flex flex-col bg-white">
                {isLoading3 && (
                    <Refresh />
                )}
                {isLoading4 && (
                    <Writing />
                )}

                {fileUpload && (
                    <Rocket />
                )}

                <SignaturePopup
                    isOpen={showSignaturePopup}
                    onClose={handleSignaturePopupClose}
                    onSave={handleSignatureSave}
                    firstName={InjectionConsentForm.first_name}
                    lastName={InjectionConsentForm.last_name}
                    isMinor={false}
                    fieldName={"patient_signature"}
                />

                {
                    dept_name === 'rsi' && (
                        <InjectionConsent
                            InjectionConsentForm={InjectionConsentForm}
                            setInjectionConsentForm={setInjectionConsentForm}
                            handleInputChange={handleInputChange}
                            handleCheckboxChange={handleCheckboxChange}
                            Paragraph={Paragraph}
                            SelectInput={SelectInput}
                            MultiSelector={MultiSelector}
                            CheckboxGroup={CheckboxGroup}
                            DynamicCheckbox={DynamicCheckbox}
                            PatientSignatureImage={PatientSignatureImage}
                            physicians={rsiphysicians}
                            nextLoader={nextLoader}
                            invalidFields={invalidFields}
                            formattedDate={formattedDate}
                            pageRef={pageRef}
                            pageTitle={pageTitle}
                            Header={Header}
                            FormHeader={FormHeader}
                            RadioGroup={RadioGroup}
                            TextInput={TextInput}
                            DiagnosisMultiSelect={DiagnosisMultiSelect}
                            ButtonGroup={ButtonGroup}
                            currentPage={currentPage}
                            handleNext={handleNext}
                            isDisabled={fileUpload}
                            handleFormSubmit={handleFormSubmit}
                            encId = {encId}
                        />
                    )}
            </div >
        </div>
    );
};

export default Injection;



